import { microfrontendURLPrefix } from '@/config';

/** Shareable URL to load a template via a pretty route. */
export function buildSearchLibraryTemplateShareUrl(templateId: number): string {
  const path = `${microfrontendURLPrefix}/template/${templateId}/load`;
  return `${window.location.origin}${path}`;
}
